var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.646,
    height: 14.467,
    viewBox: "0 0 14.646 14.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3366",
    "data-name": "Group 3366",
    transform: "translate(-1.612 -1.732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17127",
    "data-name": "Path 17127",
    d: "M2.417,4.557H12.8v.821a.6.6,0,0,0,1.2,0V4.557h1.458a.6.6,0,0,0,0-1.2H14V2.533a.6.6,0,1,0-1.2,0v.821H2.417a.6.6,0,1,0,0,1.2Z",
    transform: "translate(0 0)",
    fill: "#f16238",
    stroke: "#f16238",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17128",
    "data-name": "Path 17128",
    d: "M15.457,7.725H5.073V6.9a.6.6,0,0,0-1.2,0v.819H2.417a.6.6,0,1,0,0,1.2H3.873v.821a.6.6,0,0,0,1.2,0V8.926H15.457a.6.6,0,0,0,0-1.2Z",
    transform: "translate(0 5.651)",
    fill: "#f16238",
    stroke: "#f16238",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17129",
    "data-name": "Path 17129",
    d: "M15.456,5.538H9.536V4.717a.6.6,0,0,0-1.2,0v.821H2.416a.6.6,0,1,0,0,1.2H8.336v.819a.6.6,0,1,0,1.2,0V6.742h5.92a.6.6,0,0,0,0-1.2Z",
    transform: "translate(0.001 2.828)",
    fill: "#f16238",
    stroke: "#f16238",
    strokeWidth: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentSettings);
export default __webpack_public_path__ + "static/media/Appointment Settings.f5e5c32b66f6ba76fcdda25dfdc490db.svg";
export { ForwardRef as ReactComponent };